<template>
    <div>
        
        <div class="container" style="background:#fff;width:100%;height:auto;border-radius:30px" >
            
            
            <div style="padding-top:20px">
                <h5>
                    <b-breadcrumb :items="Navitems"></b-breadcrumb>
                </h5>
            </div>
            <!-- <img src="../../static/images/logo.png" alt="" class="DescLogo"> -->
            <div class="text-center">
                        <div v-if="$i18n.locale ==='zh'"><h3 class="ProName">{{title}}</h3></div>
                        <div v-if="$i18n.locale ==='en'"><h3 class="ProName">{{englishName}}</h3></div>
            </div>
            <b-row class="Pro_main" style="padding:30px 0">
                
                
                <b-col class="colpic">
                    <div class="" style="background:#666">
                        <b-img :src=bigimg fluid class="lisenimg"></b-img>
                    </div>
                </b-col>
                
            </b-row>
            
            
        </div>
        
        
    </div>
</template>

<script>
export default {
    name:'prodetail',    
    data(){
        return{
            bigimg:{},
            title:"",
            cur_page:1,
            otherPros:[],
            items: [
             { '品牌': 'Pioneer', '类型':'111' ,'名称':'1' },
          
            ],
            Navitems: [
            {
                text: '新闻与技术',
                to: { name: 'news' }
            },
            
            {
                text: '',
                active: true
            }
            ],
              
                    
    }
    },
    methods:{
        
        
    },
    mounted: function () {
        this.bigimg = this.$route.params.jpg
        this.title = this.$route.params.title
        this.Navitems[1]=this.title
       
      
    //   console.log(this.otherPros)
    },
    

    
}

</script>



<style>
@import url('../../../assets/css/anim.css');
    .topPic{
        width: 100%;
        height: 300px;
    }
    .cncpic .col{
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .cncborderline{
        border: 5px outset #98bf21;
    }
    .Pro_main{
        padding-top: 20px
    }
    .ProName{
        padding-top: 20px;
        padding-bottom: 20px
    }
    
    .DescLogo{
        visibility: hidden;
        animation: bottom-top 1s linear forwards;
        padding-right: 30px;
        width: 50%
    }
    .DescLogo2{
        width: 100%;
    }
    
    .commendline{
        
        border: 2px solid #666;
        width:100px ;
        
       
    }
    .jinshubg{
        background: url('../../../../static/images/proitembg2.jpg');
        background-position: center
    }
    .colpic{
            flex-basis: 0;
            -ms-flex-positive: 1;
            -webkit-box-flex: 1;
            flex-grow: 1;
            max-width: 100%
    }
    @media (max-width: 991px)
    {
        .colpic {
        flex-basis: auto !important;
    }
    }
    .lisenimg{
        max-width: 80% !important;
        padding-left: 20%;
    }
    .productName{
        cursor: pointer;
    }
    .productName:hover{
        color: #2d8cf0
    }
    .Protable{
        padding: 20px 0;
    }
</style>
